// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'function';

export const Component = () => (
  <path d='m24.426 18.63-.67.72L13.218 8.811l.719-.67L24.425 18.63Zm0-9.817L13.938 19.349l-.72-.719L23.756 8.142l.67.67ZM1.006 24.185l-.575.287-.431-.91.623-.239c1.963-.91 3.208-1.676 3.83-2.299.911-.862 1.725-2.203 2.492-3.975.814-1.963 1.771-5.077 2.873-9.435.239-.91.431-1.628.623-2.203.575-1.58 1.34-2.778 2.299-3.64C13.937.67 15.23.095 16.715 0l.047.958c-1.292.096-2.394.622-3.352 1.533-.862.814-1.533 1.915-2.06 3.257-.047.191-.238.861-.574 2.059-1.102 4.406-2.06 7.615-2.921 9.627-.814 1.915-1.725 3.352-2.682 4.31-.814.766-2.203 1.58-4.167 2.442Z' />
);

export const viewBox = '0 0 25 25';
